import { Component, Input, OnInit } from '@angular/core';
import { SwJwtService } from 'src/app/librarys/serves/sw-jwt.service';
declare var $;
@Component({
  selector: 'app-sw-instance-box',
  templateUrl: './sw-instance-box.component.html',
  styleUrls: ['./sw-instance-box.component.css']
})
export class SwInstanceBoxComponent implements OnInit {

  // 快捷操作：新增实体、新增关系、最近编辑
  @Input() state:string
  comentParams:any = {
    upOrAdd: 'Add',           // 新增/编辑实体
    instanceData: {},         // 编辑实体时需传递的参数
  }

  constructor(
    private jwt: SwJwtService
  ) { }

  ngOnInit() {
  }

  ngOnChanges(){
    console.log('instancePage',this.state);
    if(this.state == 'addInstance'){
      $('.instanceBox').css('right','0');
    }else if(this.state == 'editInstance'){
      $('.instanceBox').css('right','0');
      this.comentParams = JSON.parse(this.jwt.getToken('instanceInfo'));
    }else{
      $('.instanceBox').css('right','-660px');
    }
  }

  // 执行添加到tab页、保存、最小化、关闭操作，需关闭右侧弹出框
  componentStateChange(event){
    $('.instanceBox').css('right','-660px');
  }
}
